import {Component, OnInit, Output, EventEmitter, AfterViewInit, Input} from '@angular/core';
import {trigger, style, animate, transition, query, stagger, keyframes, state, group} from '@angular/animations';
import {CommonService} from '../common.service';
import {ApiService} from '../api.service';
import {ActivatedRoute, Router} from '@angular/router';
import index from '@angular/cli/lib/cli';

declare var $: any;

@Component({
  selector: 'app-report-level',
  animations: [
    trigger('reportLevelAnimation', [
      transition(':enter', [
        group([
          // 准备状态奖牌动画
          query('img#ready-default-icon', [
            style({opacity: 0,transform: 'scale(1.25, 1.25)'}),
            animate('1000ms 1500ms', keyframes([
                style({opacity: 0.2,transform: 'scale(1.2, 1.2)'}),
                style({opacity: 0.4,transform: 'scale(1.15, 1.15)'}),
                style({opacity: 0.6,transform: 'scale(1.1, 1.1)'}),
                style({opacity: 0.8,transform: 'scale(1.05, 1.05)'}),
                style({opacity: 1.0,transform: 'scale(1.0, 1.0)'}),
              ])
            ),
            style({opacity: 1}),
            animate('300ms 2000ms', keyframes([
                style({opacity: 0.8}),
                style({opacity: 0.6}),
                style({opacity: 0.4}),
                style({opacity: 0.2}),
                style({opacity: 0})
              ])
            ),
          ]),

          // 奖牌动画
          query('div#reportLevelIconPic', [
            style({transform: 'scale(2, 2)', opacity: 0}),
            animate('1000ms  4000ms', keyframes([
                style({transform: 'scale(1.8, 1.8)', opacity: 0.2}),
                style({transform: 'scale(1.6, 1.6)', opacity: 0.4}),
                style({transform: 'scale(1.4, 1.4)', opacity: 0.6}),
                style({transform: 'scale(1.2, 1.2)', opacity: 0.8}),
                style({transform: 'scale(1, 1)', opacity: 1})
              ])
            )
          ]),

          // 结果动画
          query('div#reportLevelResult', [
            style({opacity: 0, transform: 'scale(2,2)'}),
            animate('1000ms  4000ms', keyframes([
              style({transform: 'scale(1.8, 1.8)', opacity: 0.2}),
              style({transform: 'scale(1.6, 1.6)', opacity: 0.4}),
              style({transform: 'scale(1.4, 1.4)', opacity: 0.6}),
              style({transform: 'scale(1.2, 1.2)', opacity: 0.8}),
              style({transform: 'scale(1, 1)', opacity: 1})
            ]))
          ]),

          // 文字过度动画
          query('div#reportLevelTxt', [
            style({opacity: 0}),
            animate('1000ms  4000ms', keyframes([
                style({opacity: 0.2}),
                style({opacity: 0.4}),
                style({opacity: 0.6}),
                style({opacity: 0.8}),
                style({opacity: 1})
              ])
            )
          ]),

          // 按钮过度动画
          query('div#surveyBtn', [
            style({opacity: 0}),
            animate('1000ms  4000ms', keyframes([
                style({opacity: 0.2}),
                style({opacity: 0.4}),
                style({opacity: 0.6}),
                style({opacity: 0.8}),
                style({opacity: 1})
              ])
            )
          ]),
        ])
      ])
    ])
  ],
  templateUrl: './report-level-explain.component.html',
  styleUrls: ['./report-level-explain.component.css']
})
export class ReportLevelExplainComponent implements OnInit, AfterViewInit {

  report: any;
  reportLV: number;

  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean;

  //报告等级KA对象：从父级组件传递过来
  @Input() reportKAData: any;
  @Input() skinColor: string;

  assetsRoute: string = "../../assets";


  constructor(private commonService: CommonService,
              private apiService: ApiService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    let _this = this;
    if(this.reportKAData){
      _this.report = this.reportKAData;
      _this.reportLV = this.reportKAData.level;
    }




    // $.ajax({
    //   url: "/op/insideapi/getlevel",
    //   type: "post",
    //   dataType:'json',
    //   contentType:'application/json;charset=utf-8',
    //   data:JSON.stringify(_this.reportKAData) ,
    //   async: false,
    //   success:function(result){
    //     if(result && result != ""){
    //       _this.report = result;
    //       _this.reportLV = result.level;
    //       _this.isShowReportLv = true;
    //     }else{
    //     	_this.exitReportLevel();
    //     }
    //   },
    //   error:function(er){
    //   	_this.exitReportLevel();
    //   }
    // });
  }

  ngAfterViewInit() {
    let _this = this;

    if(this.reportKAData){
      // step1: 背景虚化
      setTimeout(function () {
        $('#reportLevel').addClass('opacity100').show();
        $('#wrap').addClass('bgBlur');
      }, 1000);

      // step2：准备icon出现-->环形进度条出现
      setTimeout(function () {
        $('[class*="chatItem-dark-"]').addClass('opacity100');
        // $('.ready-default').addClass('opacity100');
      }, 1500);


      // step3： 环形进度条发光-->抖动动画准备
      setTimeout(function () {
        let num = _this.reportLV;
        for (let i = 0, len = num; i < len; i += 1) {
          $('[class*="chatItem-light-"]').eq(i).addClass('opacity100');
        }
        $('.ready-level-icon').addClass('shake-rotate');
      }, 1500);
    }

  }


  exitReportLevel(){
    $('#reportLevel').hide();
    $('#wrap').removeClass('bgBlur');
  }


}



// WEBPACK FOOTER //
// ./src/app/report-level-explain/report-level-explain.component.ts